import ProfileComp from "../admin/admincomponent/Profile/ProfileComp";
import SchemeDetails from "../jsx/components/Scheme/SchemeDetails";
import SchemeForm from "../jsx/components/Scheme/SchemeForm";
import SubmittedSchemeForm from "../jsx/components/Scheme/SubmittedSchemeForm";
import UserSchemes from "../jsx/components/Users/UserSchemes";
import UserTicket from "../jsx/components/Users/UserTicket";
import UserNotification from "../jsx/components/Users/UserNotification";
import DeleteUserAccount from "../jsx/components/Users/DeleteUserAccount";
import EditUserProfileTable from "../jsx/components/Users/EditUserProfileTable";
import UserLogs from "../jsx/components/Users/UserLogs";
import OrganizationList from "../admin/admincomponent/organization/OrganizationList";
import IndividualList from "../admin/admincomponent/Individual/IndividualList";
import OrganizationVerficationForm from "../admin/admincomponent/organization/OrganizationVerficationForm";
import IndividualVerificationForm from "../admin/admincomponent/Individual/IndividualVerificationForm";
import InsituteVeriedUserList from "../admin/admincomponent/verifiedUser/InsituteVeriedUserList";
import VerifiedUserList from "../admin/admincomponent/verifiedUser/VerifiedUserList";
import InsituteViewUser from "../admin/admincomponent/verifiedUser/InsituteViewUser";
import ViewUser from "../admin/admincomponent/verifiedUser/ViewUser";
import Certificate from "../jsx/components/Users/Certificate";
import Accreditation from "../jsx/components/Users/Accreditation";
import AssessmentReportsPage from "../jsx/components/AssessmentReports/AssessmentReportsPage";

import Index from "../admin/admincomponent/BatchManagement/Batches/Index";
import Calendar from "../admin/admincomponent/BatchManagement/Calendar/Index";
import CreateBatch from "../admin/admincomponent/BatchManagement/Batches/CreateBatch";
import ViewBatch from "../admin/admincomponent/BatchManagement/Batches/ViewBatch";
import CreateTraining from "../admin/admincomponent/BatchManagement/Calendar/CreateTraining";
import AcademyDashboard from "../admin/admincomponent/BatchManagement/Dashboard/index";
import AttendanceReport from "../admin/admincomponent/BatchManagement/Attendance/Index";



export const allUserroutes = [
  { url: "", component: <ProfileComp /> },
  { url: "Certificate", component: <Certificate /> },
  { url: "Accreditation", component: <Accreditation /> },
  {
    url: "profile",
    component: <ProfileComp />,
  },
  {
    url: "user/edit-profile-list",
    component: <EditUserProfileTable />
  },
  {
    url: "user/logs",
    component: <UserLogs />
  },
  {
    url: "assessment-reports",
    component: <AssessmentReportsPage />
  },
  {
    url: "assessment-reports",
    component: <AssessmentReportsPage />,
  },
  {
    url: "user-grievance-management/ticket",
    component: <UserTicket />,
  },
  {
    url: "user-grievance-management/notification",
    component: <UserNotification />,
  },
  {
    url: "grant-scheme",
    component: <UserSchemes />,
  },
  {
    url: "grant-scheme/description/:encryptedSchemeId",
    component: <SchemeDetails />,
  },
  {
    url: "grant-scheme/form/:encryptedSchemeId",
    component: <SchemeForm />,
  },
  {
    url: "grant-scheme/submitted-form/:encryptedFormId",
    component: <SubmittedSchemeForm />,
  },
  {
    url: "user/delete-account",
    component: <DeleteUserAccount />,
  },
  { url: "Organization", component: <OrganizationList /> },
  { url: "Individual", component: <IndividualList /> },
  {
    url: "verification-form/:id",
    component: (
      <OrganizationVerficationForm roleWiseType="insitute" roletype="2" />
    ),
  },
  {
    url: "verification-Individual-form/:id",
    component: (
      <IndividualVerificationForm roleWiseType="individual" roletype="1" />
    ),
  },
  {
    url: "verified-institute-user",
    component: <InsituteVeriedUserList roletype="2" roleCategory="insitute" />,
  },
  {
    url: "verified-individual-user",
    component: <VerifiedUserList roletype="1" roleCategory="individual" />,
  },
  { url: "verification-view-form/:id", component: <ViewUser /> },
  {
    url: "verification-insitute-view-form/:id",
    component: <InsituteViewUser />,
  },

  {
    url: "batch-management/batches",
    component: <Index />,
  },
  {
    url: "batch-management/batches/add",
    component: <CreateBatch />,
  },
  {
    url: "batch-management/batches/viewBatch/:id",
    component: <ViewBatch />
  },
  {
    url: "batch-management/batches/update/:id",
    component: < CreateBatch />,
  },
  {
    url: "batch-management/calendar",
    component: <Calendar />,
  },
  {
    url: "batch-management/calendar/create-training",
    component: <CreateTraining />,
  },
  {
    url: "batch-management/calendar/update/:id",
    component: <CreateTraining />,

  },
  {
    url: "batch-management/dashboard",
    component: <AcademyDashboard />,
  },
  {
    url: "batch-management/attendance-report",
    component: <AttendanceReport />,
  },
];
